function initialiseIGYBAudioPlayers() {
  const players = document.querySelectorAll('[data-igyb-audio-player]');

  players.forEach((player) => {
    if (player.dataset.audioInitialised === 'true') return;

    const button = player.querySelector('.igyb-inline-audio-button');
    const playerWrap = player.querySelector('.igyb-inline-audio-player');
    const audio = player.querySelector('audio');
    const label = player.querySelector('.igyb-audio-label');
    const icon = player.querySelector('.igyb-audio-icon');

    if (!button || !playerWrap || !audio) return;

    player.dataset.audioInitialised = 'true';

    button.addEventListener('click', async () => {
      playerWrap.hidden = false;

      if (audio.paused) {
        try {
          await audio.play();

          if (label) label.textContent = 'PAUSE SOUNDTRACK';
          if (icon) icon.textContent = '❚❚';

          button.setAttribute('aria-expanded', 'true');
        } catch (error) {
          console.error('IGYB audio playback failed:', error);
        }
      } else {
        audio.pause();

        if (label) label.textContent = 'PLAY SOUNDTRACK';
        if (icon) icon.textContent = '▶';

        button.setAttribute('aria-expanded', 'false');
      }
    });

    audio.addEventListener('play', () => {
      if (label) label.textContent = 'PAUSE SOUNDTRACK';
      if (icon) icon.textContent = '❚❚';
    });

    audio.addEventListener('pause', () => {
      if (label) label.textContent = 'PLAY SOUNDTRACK';
      if (icon) icon.textContent = '▶';
    });

    audio.addEventListener('ended', () => {
      if (label) label.textContent = 'PLAY SOUNDTRACK';
      if (icon) icon.textContent = '▶';

      button.setAttribute('aria-expanded', 'false');
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialiseIGYBAudioPlayers);
} else {
  initialiseIGYBAudioPlayers();
}

document.addEventListener('shopify:section:load', initialiseIGYBAudioPlayers);